module.exports = __webpack_public_path__ + "static/tr-section-1@2x-8570a06bc0baa1121897290df6948c7b.png";